import { render, staticRenderFns } from "./editTemplate.vue?vue&type=template&id=0bc40082&"
import script from "./editTemplate.vue?vue&type=script&lang=js&"
export * from "./editTemplate.vue?vue&type=script&lang=js&"
import style0 from "./editTemplate.vue?vue&type=style&index=0&id=0bc40082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports